import script from "./ToastEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./ToastEditor.vue?vue&type=script&setup=true&lang=js"

import "./ToastEditor.vue?vue&type=style&index=0&id=5467c7aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5467c7aa"]])

export default __exports__